const KelasPararel = {
    idKelasParalel: null,
    idKelas: null,
    idSekolah: null,
    idWaliKelas: null,
    namaKelasPararel: null
}

export default KelasPararel;